export const FETCH_ALERT_HISTORY = 'fetch alert history';
export const FETCH_ALERT_HISTORY_SUCCESS = 'fetch alert history success';
export const FETCH_ALERT_HISTORY_FAILURE = 'fetch alert history failure';

export const fetchAlertHistory = (data) => ({
  type: FETCH_ALERT_HISTORY,
  payload: data
});

